// Board columns. `key` matches the calls.status value stored in Postgres.
export const STATUSES = [
  { key: 'new', label: 'New', color: '#0066cc' },
  { key: 'assigned', label: 'Assigned', color: '#8a4af3' },
  { key: 'in_progress', label: 'In Progress', color: '#c77700' },
  { key: 'resolved', label: 'Resolved', color: '#1c8a3c' },
];

export const STATUS_MAP = STATUSES.reduce((acc, s) => {
  acc[s.key] = s;
  return acc;
}, {});

// Job Progress lifecycle. `key` matches the jobs.status value stored in
// Postgres. Delivered = done; exact pickup/delivery dates are written in the
// row's expanded panel.
export const JOB_STATUSES = [
  { key: 'booked', label: 'Booked', color: '#0066cc' },
  { key: 'dispatched', label: 'Dispatched', color: '#8a4af3' },
  { key: 'picked_up', label: 'Picked Up', color: '#c77700' },
  { key: 'delivered', label: 'Delivered', color: '#1c8a3c' },
];

export const JOB_STATUS_MAP = JOB_STATUSES.reduce((acc, s) => {
  acc[s.key] = s;
  return acc;
}, {});

// $#,### with cents only when present.
export function formatMoney(n) {
  if (n === null || n === undefined || n === '') return '';
  const num = Number(n);
  if (!isFinite(num)) return '';
  return num.toLocaleString(undefined, { style: 'currency', currency: 'USD', maximumFractionDigits: 2 });
}

// A short date like "Jul 12" from a YYYY-MM-DD or ISO string, without timezone drift.
export function formatDate(value) {
  if (!value) return '';
  const s = String(value);
  const ymd = s.match(/^(\d{4})-(\d{2})-(\d{2})/);
  const d = ymd ? new Date(Number(ymd[1]), Number(ymd[2]) - 1, Number(ymd[3])) : new Date(s);
  if (isNaN(d)) return s;
  return d.toLocaleDateString(undefined, { month: 'short', day: 'numeric' });
}

export const ROLES = [
  { key: 'manager', label: 'Manager', help: 'Sees and manages every call.' },
  { key: 'admin', label: 'Administrator', help: 'Full access + can create logins.' },
];

export function formatPhone(raw) {
  if (!raw) return 'Unknown caller';
  const digits = String(raw).replace(/\D/g, '');
  const ten = digits.length === 11 && digits.startsWith('1') ? digits.slice(1) : digits;
  if (ten.length === 10) {
    return `(${ten.slice(0, 3)}) ${ten.slice(3, 6)}-${ten.slice(6)}`;
  }
  return raw;
}

export function timeAgo(iso) {
  if (!iso) return '';
  const then = new Date(iso).getTime();
  const secs = Math.max(0, Math.round((Date.now() - then) / 1000));
  if (secs < 60) return 'just now';
  const mins = Math.round(secs / 60);
  if (mins < 60) return `${mins}m ago`;
  const hrs = Math.round(mins / 60);
  if (hrs < 24) return `${hrs}h ago`;
  const days = Math.round(hrs / 24);
  return `${days}d ago`;
}

export function formatDateTime(iso) {
  if (!iso) return '';
  const d = new Date(iso);
  return d.toLocaleString(undefined, {
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
  });
}

// Digits-only phone, dropping a US country-code 1. Used to group repeat callers.
export function normalizePhone(raw) {
  if (!raw) return '';
  const digits = String(raw).replace(/\D/g, '');
  return digits.length === 11 && digits.startsWith('1') ? digits.slice(1) : digits;
}

// The key we group a caller by: their callback number, else the line they
// called from, else (last resort) their name.
export function callerKey(call) {
  const phone = normalizePhone(call.callback_number) || normalizePhone(call.caller_number);
  if (phone) return phone;
  const name = (call.caller_name || '').trim().toLowerCase();
  return name ? `name:${name}` : `id:${call.id}`;
}

// REPEAT_ALERT_THRESHOLD: a caller with this many calls (or more) raises an alert.
export const REPEAT_ALERT_THRESHOLD = 3;
